export default __webpack_public_path__ + "static/media/impact motors.b3baf019.png";